/**
 * @owner @Appboy/whats-app
 * List of all possible layouts, to share between GET and POST shapes
 */
import { z } from "zod";
import { whatsAppResponseTextMessageSchema } from "@schemas/message/whatsAppResponseTextMessageSchema";
import { whatsAppResponseMediaMessageSchema } from "@schemas/message/whatsAppResponseMediaMessageSchema";
import { whatsAppResponseQuickReplySchema } from "@schemas/message/whatsAppResponseQuickReplySchema";
import { whatsAppResponseCtaUrlMessageSchema } from "@schemas/message/whatsAppResponseCtaUrlMessageSchema";
import { whatsAppResponseListMessageSchema } from "@schemas/message/whatsAppResponseListMessageSchema";
import { whatsAppResponseFlowMessageSchema } from "@schemas/message/whatsAppResponseFlowMessageSchema";
import { whatsAppResponseProductMessageSchema } from "@schemas/message/whatsAppResponseProductMessageSchema";
import { whatsAppResponseCatalogMessageSchema } from "@schemas/message/whatsAppResponseCatalogMessageSchema";
import { whatsAppResponseMultiProductMessageSchema } from "@schemas/message/whatsAppResponseMultiProductMessageSchema";
import { whatsAppResponseSingleProductMessageSchema } from "@schemas/message/whatsAppResponseSingleProductMessageSchema";
import { whatsAppResponseCarouselMessageSchema } from "@schemas/message/whatsAppResponseCarouselMessageSchema";
import { whatsAppResponseRequestContactInfoMessageSchema } from "@schemas/message/whatsAppResponseRequestContactInfoMessageSchema";

export function buildWhatsAppResponseSchemas<T extends z.core.$ZodLooseShape>(base: T) {
  return [
    z.object({ ...base, ...whatsAppResponseTextMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseMediaMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseQuickReplySchema.shape }),
    z.object({ ...base, ...whatsAppResponseCtaUrlMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseListMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseFlowMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseProductMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseCatalogMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseMultiProductMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseSingleProductMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseCarouselMessageSchema.shape }),
    z.object({ ...base, ...whatsAppResponseRequestContactInfoMessageSchema.shape }),
  ] as const;
}
